import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import DistributorForm from './DistributorForm';
import FormToolbar from '../shared/FormToolbar';

const DistributorEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <DistributorForm {...props} />
    </SimpleForm>
  </Edit>
);

export default DistributorEdit;
